<template>
  <div data-cy="chat-typing-indicator">
    <div class="rounded-lg px-4 py-3">
      <div class="flex space-x-2">
        <div class="h-2 w-2 animate-bounce rounded-full bg-gray-400"></div>
        <div
          class="h-2 w-2 animate-bounce rounded-full bg-gray-400"
          style="animation-delay: 0.2s"
        ></div>
        <div
          class="h-2 w-2 animate-bounce rounded-full bg-gray-400"
          style="animation-delay: 0.4s"
        ></div>
      </div>
    </div>
  </div>
</template>
